<template>
  <v-app>
    <v-toolbar app clipped-left clipped-right fixed flat color="white">
      <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>Handel's Messiah</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn flat :to="{name: 'about'}">About</v-btn>
    </v-toolbar>
    <v-navigation-drawer app clipped :temporary="false" v-model="drawer">
      <v-list class="pt-0" dense>
        <v-divider style="border-color: white; color: white;"></v-divider>

        <v-list-tile v-for="(item, i) in data" :key="i" :to="{name: 'day', params: {id: i + 1}}">
          <v-list-tile-content>
            <v-list-tile-title>Day {{ i + 1 }} - {{ dates[i] }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-content style="background-color: white;">
      <router-view></router-view>
    </v-content>
    <v-footer app><span style="padding: 8px;">© messiahadvent.com - 2018 - v{{version}}</span></v-footer>
  </v-app>
</template>

<script>
import { version } from '../package.json'
import { data } from '@/assets/data.json'
import { getDay } from '@/components/dateCalc'
import moment from 'moment'

export default {
  name: 'App',
  data () {
    return {
      data: data,
      drawer: true,
      version: version
    }
  },

  computed: {
    dates: function () {
      var dates = []
      var today = getDay() - 1
      console.log(today)

      for (var i = 0; i < 28; i++) {
        dates.push(moment().add(i - today, 'days').format('MMMM, Do'))
      }

      return dates
    }
  }
}
</script>
